(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4464],{

/***/ 56267:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings/roles",
      function () {
        return __webpack_require__(92684);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83083);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10078);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__);







const Sidebar = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const { groups , menu  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const propsMenu = props.menu.filter((it)=>it);
        if (!propsMenu.length) return {
            groups: null,
            menu: []
        };
        if ("menu" in propsMenu[0]) {
            const groups = propsMenu.map((it)=>({
                    ...it,
                    menu: it.menu.filter((it)=>it)
                }));
            const menu = groups.map((it)=>it.menu).flat();
            return {
                groups,
                menu
            };
        } else {
            return {
                groups: null,
                menu: propsMenu
            };
        }
    }, [
        props.menu
    ]);
    const checkActiveForDescktop = (menuItem)=>{
        if (router.asPath.startsWith(menuItem.additionalHref)) return true;
        switch(router.asPath){
            case menuItem.href:
                return true;
            case menuItem.additionalHref:
                return true;
            default:
                if (!menuItem.exact) return router.asPath.startsWith(menuItem.href);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        const activeLink = menu.find((elem)=>{
            if (elem.exact) return router.asPath === elem.additionalHref;
            return router.asPath.startsWith(elem.href);
        });
        setActiveMenu(activeLink);
    }, [
        menu,
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar), props.sticky && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar_adaptive),
                children: activeMenu ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: props.mainHref,
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        activeMenu.label,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().spacer)
                        })
                    ]
                }) : menu.map((it)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().adaptive_item),
                        href: it.exact ? it.additionalHref : it.href,
                        children: it.label
                    }, it.href))
            }),
            groups === null || groups === void 0 ? void 0 : groups.map((it, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                    children: [
                        it.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().group_title),
                            children: it.title
                        }),
                        it.menu.map((it)=>{
                            const active = checkActiveForDescktop(it);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: it.href,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                children: it.label
                            }, it.href);
                        })
                    ]
                }, key)),
            !groups && menu.map((it)=>{
                const active = checkActiveForDescktop(it);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: it.href,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                    children: it.label
                }, it.href);
            })
        ]
    });
};
Sidebar.defaultProps = {
    sticky: true
};


/***/ }),

/***/ 98730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _title_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30620);
/* harmony import */ var _title_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_title_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Title = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_title_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: props.children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_title_module_scss__WEBPACK_IMPORTED_MODULE_3___default().actions),
                children: props.actions
            })
        ]
    });
};
Title.defaultProps = {};


/***/ }),

/***/ 47656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ WithSidebarContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57711);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11682);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const WithSidebarContainer = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const hideOnMobile = router.asPath === props.mainHref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
        fullWidth: props.fullWidth,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().with_sidebar_container), props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar),
                children: props.sidebar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), hideOnMobile && (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide_on_mobile)),
                children: props.children
            })
        ]
    });
};
WithSidebarContainer.defaultProps = {};


/***/ }),

/***/ 80665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useMyPermissions; }
/* harmony export */ });
/* unused harmony export convertPermissions */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22823);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94840);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32636);


const convertPermissions = (roleType, permissions)=>{
    const set = new Set(permissions);
    const isOwner = roleType === shared_api__WEBPACK_IMPORTED_MODULE_1__/* .CompanyEmployeeRoleType.OWNER */ .Or.OWNER;
    return {
        finances: {
            budgets: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            plannings: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            fundingRequests: {
                create: true,
                readAll: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_READ_ALL */ .Mn.CLAIM_READ_ALL),
                acceptOrDecline: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING */ .Mn.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE),
                close: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE) || set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF),
                pay: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF)
            },
            funds: {
                withdraw: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_WITHDRAW */ .Mn.FUND_WITHDRAW),
                deposit: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_DEPOSIT */ .Mn.FUND_DEPOSIT),
                readProtected: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_SECURED_READ */ .Mn.FUND_SECURED_READ)
            }
        },
        company: {
            general: {
                update: isOwner,
                delete: isOwner
            },
            members: {
                invite: isOwner,
                update: isOwner,
                remove: isOwner
            },
            roles: {
                write: isOwner
            }
        }
    };
};
const useMyPermissions = (companySlug)=>{
    var _me_data;
    const me = shared_api__WEBPACK_IMPORTED_MODULE_3__/* .api.companyEmployee.useCompanyEmployeeMe */ .h.companyEmployee.useCompanyEmployeeMe(companySlug);
    const role = (_me_data = me.data) === null || _me_data === void 0 ? void 0 : _me_data.companyEmployeeRole;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>!role ? null : convertPermissions(role.type, role.permissions), [
        role
    ]);
};


/***/ }),

/***/ 59906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ CompanyLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/auth/model/auth-guard.model.tsx
var auth_guard_model = __webpack_require__(95244);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/company/entities/company/company-expired/company-expired.module.scss
var company_expired_module = __webpack_require__(60978);
var company_expired_module_default = /*#__PURE__*/__webpack_require__.n(company_expired_module);
;// CONCATENATED MODULE: ./src/modules/company/entities/company/company-expired/company-expired.tsx




const CompanyExpired = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((company_expired_module_default()).company_expired, props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (company_expired_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Для этой компании закончился период доступа"
            })
        })
    });
};
CompanyExpired.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/header-dashboard/header-dashboard.tsx + 13 modules
var header_dashboard = __webpack_require__(35622);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-navigation/header-navigation.tsx
var header_navigation = __webpack_require__(20168);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-title/header-title.tsx
var header_title = __webpack_require__(35629);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/pages/[company]/_layout.tsx








const CompanyLayout = (props)=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(companySlug);
    (0,auth_guard_model/* useGuardAuthedOnly */.T)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_dashboard/* HeaderDashboard */.w, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_navigation/* HeaderNavigation */.F, {
                menu: [
                    {
                        label: "Финансы",
                        href: _router/* default.company */.Z.company(companySlug).finances.href
                    },
                    // { label: "Департаменты", href: pages.company(companySlug).departments.href },
                    {
                        label: "Настройки",
                        href: _router/* default.company */.Z.company(companySlug).settings.href
                    }
                ],
                sticky: props.stickyNavigation
            }),
            company.data && !company.data.hasAccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyExpired, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_title/* HeaderTitle */.G, {
                        fullWidth: true,
                        back: props.back,
                        actions: props.actions,
                        children: props.title
                    }),
                    props.children
                ]
            })
        ]
    });
};
CompanyLayout.defaultProps = {
    stickyNavigation: true
};


/***/ }),

/***/ 10830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CompanySettingsLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47656);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6480);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8254);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59906);






const CompanySettingsLayout = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const slug = router.query.company;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_3__/* .CompanyLayout */ .q, {
        title: "Настройки",
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_4__/* .WithSidebarContainer */ .I, {
            mainHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
            sidebar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_6__/* .Sidebar */ .Y, {
                mainHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
                menu: [
                    {
                        label: "Общие",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
                        exact: true,
                        additionalHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.general.href
                    },
                    {
                        label: "Сотрудники",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.users.href
                    },
                    {
                        label: "Роли",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.roles.href
                    }
                ]
            }),
            children: props.children
        })
    });
};


/***/ }),

/***/ 92684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ roles_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/api/back/_generated/models/CompanyRolePermission.ts
var CompanyRolePermission = __webpack_require__(94840);
// EXTERNAL MODULE: ./src/shared/ui/checkbox/checkbox.tsx + 1 modules
var checkbox_checkbox = __webpack_require__(49329);
// EXTERNAL MODULE: ./src/modules/company/entities/role/role-permissions.module.scss
var role_permissions_module = __webpack_require__(44207);
var role_permissions_module_default = /*#__PURE__*/__webpack_require__.n(role_permissions_module);
;// CONCATENATED MODULE: ./src/modules/company/entities/role/role-permissions.tsx






const RolePermissions = (props)=>{
    const checkbox = (permission)=>({
            checked: props.value.has(permission),
            onChange: (checked)=>{
                const result = new Set(props.value);
                if (checked) {
                    result.add(permission);
                } else {
                    result.delete(permission);
                }
                return props.onChange(result);
            },
            disabled: props.readOnly
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((role_permissions_module_default()).role_permissions, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (role_permissions_module_default()).group,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (role_permissions_module_default()).label,
                        children: "Заявки"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.CLAIM_READ_ALL */.Mn.CLAIM_READ_ALL),
                        children: "Видеть все"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.CLAIM_APPROVE */.Mn.CLAIM_APPROVE),
                        children: "Утверждать"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING */.Mn.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING),
                        children: "Допускать до планирования"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.CLAIM_PAY_OFF */.Mn.CLAIM_PAY_OFF),
                        children: "Выплачивать"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (role_permissions_module_default()).group,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (role_permissions_module_default()).label,
                        children: "Финансовые планирования"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.FINANCIAL_PLAN_READ */.Mn.FINANCIAL_PLAN_READ),
                        children: "Видеть"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */.Mn.FINANCIAL_PLAN_CONDUCT),
                        children: "Проводить"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.FINANCIAL_PLAN_APPROVE */.Mn.FINANCIAL_PLAN_APPROVE),
                        children: "Утверждать"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (role_permissions_module_default()).group,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (role_permissions_module_default()).label,
                        children: "Фонды"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.FUND_WITHDRAW */.Mn.FUND_WITHDRAW),
                        children: "Делать списания"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.FUND_DEPOSIT */.Mn.FUND_DEPOSIT),
                        children: "Делать пополнения"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                        ...checkbox(CompanyRolePermission/* CompanyRolePermission.FUND_SECURED_READ */.Mn.FUND_SECURED_READ),
                        children: "Доступ к защищенным фондам"
                    })
                ]
            })
        ]
    });
};
RolePermissions.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/my-permissions/use-my-permissions.ts
var use_my_permissions = __webpack_require__(80665);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/lib/use-api-method.ts
var use_api_method = __webpack_require__(24453);
// EXTERNAL MODULE: ./src/shared/ui/entity-form/entity-form.tsx
var entity_form = __webpack_require__(37641);
// EXTERNAL MODULE: ./src/shared/ui/error/error.tsx
var error = __webpack_require__(64871);
// EXTERNAL MODULE: ./src/shared/ui/button/button.tsx
var button_button = __webpack_require__(76780);
// EXTERNAL MODULE: ./src/shared/ui/input/input.tsx
var input = __webpack_require__(99088);
// EXTERNAL MODULE: ./src/modules/company/features/role-create/role-create-form.module.scss
var role_create_form_module = __webpack_require__(699);
var role_create_form_module_default = /*#__PURE__*/__webpack_require__.n(role_create_form_module);
;// CONCATENATED MODULE: ./src/modules/company/features/role-create/role-create-form.tsx









const RoleCreateForm = (props)=>{
    var _useMyPermissions;
    const hasPermission = (_useMyPermissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug)) === null || _useMyPermissions === void 0 ? void 0 : _useMyPermissions.company.roles.write;
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyRbac.companyEmployeeRoleCreate */.h.companyRbac.companyEmployeeRoleCreate);
    const [name, setName] = (0,react.useState)("");
    const [permissions, setPermissions] = (0,react.useState)(()=>new Set());
    const valid = !!name.trim();
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!valid) return;
        await submit.call(props.companySlug, {
            name,
            permissions: Array.from(permissions)
        });
        setName("");
        setPermissions(new Set());
        await props.onSuccess();
    };
    const tabIndex = hasPermission ? undefined : -1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: classnames_default()((role_create_form_module_default()).role_create_form, props.className),
        style: props.style,
        id: props.htmlId,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity_form/* EntityForm */.D, {
            title: "Новая роль",
            footerNote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                        label: null,
                        children: submit.error.message
                    }),
                    !hasPermission && "Создавать роли может только владелец компании"
                ]
            }),
            disabled: !hasPermission,
            primaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                size: "small",
                loading: submit.loading,
                disabled: !valid,
                tabIndex: tabIndex,
                children: "Добавить"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                    placeholder: "Название",
                    value: name,
                    onChange: (e)=>setName(e.target.value),
                    tabIndex: tabIndex
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RolePermissions, {
                    value: permissions,
                    onChange: setPermissions,
                    className: (role_create_form_module_default()).permissions
                })
            ]
        })
    });
};
RoleCreateForm.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/entity/entity.tsx + 3 modules
var entity = __webpack_require__(51978);
// EXTERNAL MODULE: ./src/shared/ui/icon/down.svg
var down = __webpack_require__(83083);
// EXTERNAL MODULE: ./src/modules/company/entities/role/role-entity.module.scss
var role_entity_module = __webpack_require__(279);
var role_entity_module_default = /*#__PURE__*/__webpack_require__.n(role_entity_module);
;// CONCATENATED MODULE: ./src/modules/company/entities/role/role-entity.tsx







const RoleEntity = (props)=>{
    const [open, setOpen] = (0,react.useState)(props.initialOpen || false);
    const [permissions, setPermissions] = (0,react.useState)(()=>new Set(props.data.permissions));
    const [touched, setTouched] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setPermissions(new Set(props.data.permissions));
        setTouched(false);
    }, [
        props.data.permissions
    ]);
    const onChangePermissions = (value)=>{
        setTouched(true);
        setPermissions(value);
    };
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyRbac.companyEmployeeRoleChangePermissions */.h.companyRbac.companyEmployeeRoleChangePermissions);
    const onSubmit = async ()=>{
        await submit.call(props.companySlug, props.data.id, {
            permissions: Array.from(permissions)
        });
        await props.onUpdated();
        setTouched(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                menuItems: props.menuItems,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (role_entity_module_default()).opener,
                        onClick: (e)=>{
                            e.stopPropagation();
                            setOpen((it)=>!it);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(down/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                        title: props.data.name
                    }),
                    props.data.type === "DEFAULT" && /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                        description: "По умолчанию",
                        right: true
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(entity_form/* EntityForm */.D, {
                footerNote: submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                    label: null,
                    children: submit.error.message
                }),
                disabled: props.readOnly,
                primaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    size: "small",
                    disabled: !touched || props.data.type !== "COMMON",
                    onClick: onSubmit,
                    children: "Сохранить"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RolePermissions, {
                    value: permissions,
                    onChange: onChangePermissions,
                    readOnly: props.data.type !== "COMMON"
                })
            })
        ]
    });
};
RoleEntity.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/modal.tsx + 7 modules
var modal = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/shared/ui/loading-dots/loading-dots.tsx
var loading_dots = __webpack_require__(42966);
;// CONCATENATED MODULE: ./src/modules/company/features/role-rename/role-rename-modal.tsx





const RoleRenameModal = (props)=>{
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyRbac.companyEmployeeRoleChangeName */.h.companyRbac.companyEmployeeRoleChangeName);
    const [name, setName] = (0,react.useState)(props.data.name);
    const valid = !!name.trim();
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!name) return;
        await submit.call(props.companySlug, props.data.id, {
            name
        });
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Название роли"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            autoFocus: true,
                            placeholder: "Название роли",
                            value: name,
                            onChange: (e)=>setName(e.target.value)
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading || !valid,
                            children: !submit.loading ? "Сохранить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Сохраняем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
RoleRenameModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/lib/format-date.ts
var format_date = __webpack_require__(68984);
;// CONCATENATED MODULE: ./src/modules/company/features/role-duplicate/role-duplicate-modal.tsx





const RoleDuplicateModal = (props)=>{
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyRbac.companyEmployeeRoleCreate */.h.companyRbac.companyEmployeeRoleCreate);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.companySlug, {
            name: props.data.name + " (2)",
            permissions: props.data.permissions
        });
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Дублирование роли"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    title: props.data.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    right: true,
                                    description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "Создана ",
                                            (0,format_date/* formatDate */.p6)(props.data.createdAt, {
                                                month: "long"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Дублировать" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Дублируем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
RoleDuplicateModal.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/company/features/role-delete/role-delete-modal.tsx





const RoleDeleteModal = (props)=>{
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyRbac.companyEmployeeRoleRemove */.h.companyRbac.companyEmployeeRoleRemove);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.companySlug, props.data.id);
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 450,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Удаление роли"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    title: props.data.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    right: true,
                                    description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "Создана ",
                                            (0,format_date/* formatDate */.p6)(props.data.createdAt, {
                                                month: "long"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Отмена"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Удалить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Удаление"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
RoleDeleteModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/api/back/_generated/models/CompanyEmployeeRoleType.ts
var CompanyEmployeeRoleType = __webpack_require__(22823);
// EXTERNAL MODULE: ./src/shared/lib/use-modal.tsx
var use_modal = __webpack_require__(74363);
// EXTERNAL MODULE: ./src/shared/ui/list/list.tsx
var list = __webpack_require__(30954);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/item/menu-item.tsx
var menu_item = __webpack_require__(38234);
;// CONCATENATED MODULE: ./src/modules/company/widgets/role-list/role-list.tsx








const RoleList = (props)=>{
    var _useMyPermissions;
    const roleWritePermission = (_useMyPermissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug)) === null || _useMyPermissions === void 0 ? void 0 : _useMyPermissions.company.roles.write;
    const onRename = (0,react.useCallback)((data)=>{
        return use_modal/* Modals.open */.nK.open(RoleRenameModal, {
            companySlug: props.companySlug,
            data,
            onSuccess: ()=>{
                var _props_mutate;
                return (_props_mutate = props.mutate) === null || _props_mutate === void 0 ? void 0 : _props_mutate.call(props);
            }
        });
    }, [
        props.companySlug,
        props.mutate
    ]);
    const onDuplicate = (0,react.useCallback)((data)=>{
        return use_modal/* Modals.open */.nK.open(RoleDuplicateModal, {
            companySlug: props.companySlug,
            data,
            onSuccess: ()=>{
                var _props_mutate;
                return (_props_mutate = props.mutate) === null || _props_mutate === void 0 ? void 0 : _props_mutate.call(props);
            }
        });
    }, [
        props.companySlug,
        props.mutate
    ]);
    const onDelete = (0,react.useCallback)((data)=>{
        return use_modal/* Modals.open */.nK.open(RoleDeleteModal, {
            companySlug: props.companySlug,
            data,
            onSuccess: ()=>{
                var _props_mutate;
                return (_props_mutate = props.mutate) === null || _props_mutate === void 0 ? void 0 : _props_mutate.call(props);
            }
        });
    }, [
        props.companySlug,
        props.mutate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
        ...props,
        renderItem: (it)=>{
            const editable = it.type === CompanyEmployeeRoleType/* CompanyEmployeeRoleType.COMMON */.Or.COMMON;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoleEntity, {
                data: it,
                companySlug: props.companySlug,
                onUpdated: ()=>{
                    var _props_mutate;
                    return (_props_mutate = props.mutate) === null || _props_mutate === void 0 ? void 0 : _props_mutate.call(props);
                },
                readOnly: !roleWritePermission,
                menuItems: roleWritePermission && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                            onClick: ()=>onRename(it),
                            children: "Переименовать"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                            onClick: ()=>onDuplicate(it),
                            children: "Дублировать"
                        }),
                        editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                            type: "error",
                            onClick: ()=>onDelete(it),
                            children: "Удалить"
                        })
                    ]
                })
            });
        }
    });
};
RoleList.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/title/title.tsx
var title = __webpack_require__(98730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/[company]/settings/_layout.tsx
var _layout = __webpack_require__(10830);
;// CONCATENATED MODULE: ./src/pages/[company]/settings/roles.page.tsx







const CompanyRolesPage = ()=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const roles = init/* api.companyRbac.useCompanyEmployeeRoleList */.h.companyRbac.useCompanyEmployeeRoleList(companySlug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_layout/* CompanySettingsLayout */.Q, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* Title */.D, {
                children: "Роли"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoleCreateForm, {
                companySlug: companySlug,
                onSuccess: roles.mutate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoleList, {
                companySlug: companySlug,
                ...roles
            })
        ]
    });
};
/* harmony default export */ var roles_page = (CompanyRolesPage);


/***/ }),

/***/ 68984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bh": function() { return /* binding */ formatMonth; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30120);

const formatDateTime = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    const data = new Date(value);
    const opts = {
        // year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        ...options
    };
    if (data.getFullYear() === currentYear) {
        delete opts.year;
    }
    let result = data.toLocaleString("ru-RU", opts);
    if (opts.month === "short") {
        result = result.replace(".", "");
    }
    return result;
};
const formatTime = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    return new Date(value).toLocaleString("ru-RU", {
        hour: "2-digit",
        minute: "2-digit",
        ...options
    });
};
const currentYear = new Date().getFullYear();
const formatDate = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    const data = new Date(value);
    const opts = {
        // year: "numeric",
        month: "short",
        day: "2-digit",
        ...options
    };
    if (data.getFullYear() === currentYear) {
        delete opts.year;
    }
    let result = data.toLocaleString("ru-RU", opts);
    if (opts.month === "short") {
        result = result.replace("марта", "мар").replace("февр.", "фев").replace(".", "");
    }
    return result;
};
const formatMonth = (month)=>{
    if (month === undefined || month === null) return;
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.local */ .ou.local(2000, Number(month)).setLocale("ru").toLocaleString({
        month: "long"
    });
};


/***/ }),

/***/ 49329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/ui/icon/checkbox-on.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckboxOn = function SvgCheckboxOn(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 20 20",
    width: 16
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m14 7-5.5 5.5L6 10",
    stroke: "var(--geist-background)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
};
/* harmony default export */ var checkbox_on = (SvgCheckboxOn);
// EXTERNAL MODULE: ./src/shared/ui/checkbox/checkbox.module.scss
var checkbox_module = __webpack_require__(80405);
var checkbox_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_module);
;// CONCATENATED MODULE: ./src/shared/ui/checkbox/checkbox.tsx





const Checkbox = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        className: classnames_default()((checkbox_module_default()).checkbox, props.disabled && (checkbox_module_default()).disabled, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (checkbox_module_default()).check,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        checked: props.checked,
                        onChange: (e)=>{
                            var _props_onChange;
                            return (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, e.target.checked);
                        },
                        disabled: props.disabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (checkbox_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_on, {})
                    })
                ]
            }),
            props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (checkbox_module_default()).text,
                children: props.children
            })
        ]
    });
};
Checkbox.defaultProps = {};


/***/ }),

/***/ 60978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company_expired":"company-expired_company_expired__1K5vq","inner":"company-expired_inner__2NWWa"};

/***/ }),

/***/ 279:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 44207:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"role_permissions":"role-permissions_role_permissions__3sKiK","group":"role-permissions_group__pqkZF","label":"role-permissions_label__uYX3x"};

/***/ }),

/***/ 699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"permissions":"role-create-form_permissions__vGobo"};

/***/ }),

/***/ 10078:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__sYHpc","sticky":"sidebar_sticky__tqhuP","sidebar_adaptive":"sidebar_sidebar_adaptive__It1u0","adaptive_item":"sidebar_adaptive_item__UCFjh","title":"sidebar_title__41UVT","item":"sidebar_item__3MhXw","active":"sidebar_active__ezSut","group_title":"sidebar_group_title__gZU9o","spacer":"sidebar_spacer__WlMwR"};

/***/ }),

/***/ 30620:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__UQ87O"};

/***/ }),

/***/ 11682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"with_sidebar_container":"with-sidebar-container_with_sidebar_container__nlbUn","sidebar":"with-sidebar-container_sidebar__s3m9i","main":"with-sidebar-container_main__UyQ8Z","hide_on_mobile":"with-sidebar-container_hide_on_mobile__F4a_D"};

/***/ }),

/***/ 80405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__ul_7n","disabled":"checkbox_disabled__e6mmJ","check":"checkbox_check__i_Luq","icon":"checkbox_icon__Pj_YQ","text":"checkbox_text__jWfup"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7165,5675,1664,6657,4321,4894,5555,9774,2888,179], function() { return __webpack_exec__(56267); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);